import {
	Resources,
	useResource,
} from "web_myplann/Infrastructure/Translations/Resources";
import { BankProductCreateFormFields } from "web_myplann/Portfolio/Forms/BankProductForm/BankProductCreateFormFields";
import { useCreateBankProductForm } from "web_myplann/Portfolio/Forms/BankProductForm/useCreateBankProductForm";
import { PortfolioFormShell } from "web_myplann/Portfolio/PortfolioShared/PortfolioFormShell";

export const CreateBankProductForm = () => {
	const { t } = useResource();
	const { form, onSubmit, isPending } = useCreateBankProductForm();

	return (
		<PortfolioFormShell
			onSubmit={onSubmit}
			submitLabel={t(Resources.Portfolio.AddShared.submit)}
			disabled={!form.formState.isDirty}
			loading={isPending}
		>
			<BankProductCreateFormFields control={form.control} />
		</PortfolioFormShell>
	);
};
